<template>
    <b-col lg="10">
      <b-form-group class="text-left"
                    label-class="font-weight-bold pt-0"
                    :label="label">
        <b-form-radio v-model="selected"
                      :name="codeQuestion"
                      v-for="item in answers"
                      :key="item.point"
                      :value="item">
          {{item.value}}
        </b-form-radio>
      </b-form-group>
    </b-col>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'FormRadio',
  props: {
    label: {
      type: String,
      default: ''
    },
    model: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    codeQuestion: {
      type: String,
      default: ''
    },
    answers: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      selected: -1
    }
  },
  beforeMount () {
    const point = this.value[this.codeQuestion]
    const result = _.find(this.answers,
      {point: point})
    if (this.selected !== result) {
      this.selected = result
    }
  },
  watch: {
    value (val) {
      const point = val[this.codeQuestion]
      if (!_.isEmpty(point)) {
        const result = _.find(this.answers,
          {point: point})
        if (this.selected !== result) {
          this.selected = result
        }
      }
    },
    selected (val) {
      if (!_.isUndefined(val)) {
        const item = {codeQuestion: this.codeQuestion,
          value: val.point}
        this.$emit('action-output', item)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/FormRadio.vue